import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export const AddressParagraph = ({ address }) => {
    const { addressLine1, addressLine2, state, zipCode, city } = address;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { "data-qm-mask": "", "data-testid": "addressLineOneContainer" }, addressLine1),
        addressLine2 && (React.createElement(Typography, { "data-qm-mask": "", "data-testid": "addressLineTwoContainer" }, addressLine2)),
        React.createElement(Typography, { "data-qm-mask": "" },
            city,
            ", ",
            state,
            " ",
            zipCode)));
};
AddressParagraph.displayName = 'AddressParagraph';
